import { render, staticRenderFns } from "./RegisterPay.vue?vue&type=template&id=b16d4eb8"
import script from "./RegisterPay.vue?vue&type=script&lang=js"
export * from "./RegisterPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports